import { Button, Modal } from '@elva/ui';

export type DeleteFormTarget =
  | { type: 'single'; id: string; name: string }
  | { type: 'bulk'; ids: string[] };

interface DeleteFormConfirmDialogProps {
  target: DeleteFormTarget;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteFormConfirmDialog({
  target,
  isDeleting = false,
  onClose,
  onConfirm,
}: DeleteFormConfirmDialogProps) {
  const title = target.type === 'single' ? 'Delete form?' : `Delete ${target.ids.length} forms?`;
  const message =
    target.type === 'single'
      ? `Are you sure you want to delete “${target.name}”? This cannot be undone. Forms with open assignments cannot be deleted.`
      : `Are you sure you want to delete ${target.ids.length} selected forms? This cannot be undone. Forms with open assignments cannot be deleted.`;

  return (
    <Modal
      title={title}
      onClose={onClose}
      footer={
        <>
          <Button variant="secondary" size="sm" disabled={isDeleting} onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            size="sm"
            disabled={isDeleting}
            onClick={onConfirm}
          >
            {isDeleting ? 'Deleting…' : 'Yes, delete'}
          </Button>
        </>
      }
    >
      <p className="m-0 text-[13.5px] leading-relaxed text-[var(--ink-2)]">{message}</p>
    </Modal>
  );
}
